export default __webpack_public_path__ + "static/logo2-085700a81f286785c3a586d697e52763.png";